import { request } from '@umijs/max';
import type {
  MenuFormBo,
  MenuTreeBo,
  MenuTreeItemVo,
  MenuTreeVo,
} from './type';

/**
 * 获取树状菜单（全量，不区分调用者角色）
 * 用于"菜单管理""角色管理"等需要看到/勾选完整菜单结构的后台配置页面。
 * 渲染导航侧边栏请用 queryMyMenuTree，否则未被角色授权的菜单也会展示出来。
 * @param params 查询参数
 */
export async function queryMenuTree(params?: MenuTreeBo) {
  return request<MenuTreeVo>('/system/sysMenu/tree', {
    method: 'GET',
    params,
  });
}

/**
 * 获取当前登录用户可访问的菜单树（按角色授权范围过滤），用于渲染导航侧边栏。
 * @param appType 平台类型，总部端固定传 "HQ"
 */
export async function queryMyMenuTree(appType: string) {
  return request<{ data: MenuTreeItemVo[] }>('/system/sysMenu/my-tree', {
    method: 'GET',
    params: { appType },
  });
}

/**
 * 获取菜单详情
 * @param id 菜单ID
 */
export async function getMenuDetail(id?: number) {
  return request(`/system/sysMenu/${id}`, {
    method: 'GET',
  });
}

/**
 * 新增菜单
 * @param data 菜单表单数据
 */
export async function addMenu(data: MenuFormBo) {
  return request('/system/sysMenu', {
    method: 'POST',
    data,
  });
}

/**
 * 更新菜单
 * @param data 菜单表单数据
 */
export async function updateMenu(data: MenuFormBo) {
  return request(`/system/sysMenu/${data.id}`, {
    method: 'PUT',
    data,
  });
}

/**
 * 删除菜单
 * @param id 菜单ID
 */
export async function deleteMenu(id: number) {
  return request(`/system/sysMenu/${id}`, {
    method: 'DELETE',
  });
}

/**
 * 更新菜单排序
 * @param menuIds 菜单ID列表（按新顺序排列）
 */
export async function updateMenuSort(menuIds: number[]) {
  return request('/system/sysMenu/sort', {
    method: 'PUT',
    data: menuIds,
  });
}
